import { ITierProductHighlights } from "api/interfaces/get-page-details/product-page.type";
import RenderTag from "./RenderTag";
import styles from "./productTags.module.scss";

interface IProps {
  productHighlights: ITierProductHighlights[],
  productTags: string[],
}

function ProductTagsCategory(props: IProps) {
  const { productTags, productHighlights = [] } = props;

  function findDescriptionFromHighlights(tagValue: string) {
    const obj = productHighlights.find((eachHightlight) => eachHightlight.value === tagValue);
    return obj ? obj.description : "NA";
  }
  return (
    <div className={styles.category_tags}>
      {productTags.map((tag, index: number) => {
        const tagValue = tag;
        const desc = findDescriptionFromHighlights(tagValue);
        return (
          <RenderTag
            key={index}
            {...{ desc, tagValue }}
            circular
          />
        );
      })}
    </div>
  );
}

export default ProductTagsCategory;
